// Preparation for a standalone component
export enum LoadState {
  idle,
  loading,
  loaded,
}

export enum ErrorTypes {
  twoFactorAuthenticationException = 'TwoFactorAuthenticationException',
  invalidTwoFactorAuthenticationException = 'InvalidTwoFactorAuthenticationException',
}
